<template>
  <div class="expert-home">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="header-left">
        <span class="logo">{{ companyName }}</span>
        <span class="title">专家信息管理系统</span>
      </div>
      <div class="header-right">
        <span class="welcome">欢迎您，{{ expertInfo.expertName }}</span>
        <el-button type="text" icon="el-icon-key" @click="showPasswordDialog">修改密码</el-button>
        <el-button type="text" icon="el-icon-switch-button" class="logout-btn" @click="handleLogout">退出登录</el-button>
      </div>
    </div>

    <!-- 主内容区域 -->
    <div class="main-content">
      <!-- 专家信息卡片 -->
      <div class="info-card">
        <div class="card-header">
          <i class="el-icon-user"></i>
          <span>专家基本信息</span>
        </div>
        <div class="card-body">
          <div class="avatar-section">
            <div class="avatar">
              <i class="el-icon-user-solid"></i>
            </div>
            <div class="name">{{ expertInfo.expertName }}</div>
          </div>
          <div class="info-section">
            <div class="info-row">
              <div class="info-item">
                <label>专家姓名</label>
                <span>{{ expertInfo.expertName || '-' }}</span>
              </div>
              <div class="info-item">
                <label>手机号码</label>
                <span>{{ expertInfo.phone || '-' }}</span>
              </div>
            </div>
            <div class="info-row">
              <div class="info-item">
                <label>身份证号</label>
                <span>{{ expertInfo.idCard || '-' }}</span>
              </div>
              <div class="info-item">
                <label>注册时间</label>
                <span>{{ expertInfo.createTime || '-' }}</span>
              </div>
            </div>
            <div class="info-row">
              <div class="info-item">
                <label>更新时间</label>
                <span>{{ expertInfo.updateTime || '-' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 修改密码弹窗 -->
    <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" width="450px" :close-on-click-modal="false"
      class="password-dialog">
      <div class="password-form">
        <div class="form-item">
          <label>手机号</label>
          <el-input v-model="passwordForm.phone" disabled></el-input>
        </div>
        <div class="form-item captcha-row">
          <label>验证码</label>
          <div class="captcha-input-wrap">
            <el-input v-model="passwordForm.captchaCode" placeholder="请输入验证码"></el-input>
            <el-button type="primary" :disabled="countdown > 0" @click="sendSmsCode">
              {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
            </el-button>
          </div>
        </div>
        <div class="form-item">
          <label>新密码</label>
          <el-input v-model="passwordForm.loginPassword" type="password" placeholder="请输入新密码" show-password></el-input>
        </div>
        <div class="form-item">
          <label>确认密码</label>
          <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码"
            show-password></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleResetPassword">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getExpertInfo, resetLoginPassword, sendSmsCode } from '@/api/modules/expertBank'
import Cookies from 'js-cookie'
export default {
  name: 'ExpertBankHome',
  data() {
    return {
      expertInfo: {
        id: '',
        expertName: '',
        idCard: '',
        phone: '',
        createTime: '',
        updateTime: ''
      },
      passwordDialogVisible: false,
      passwordForm: {
        phone: '',
        captchaCode: '',
        captchaUuid: '',
        loginPassword: '',
        confirmPassword: ''
      },
      countdown: 0,
      timer: null
    }
  },
  computed: {
    companyName() {
      return this.$channelMaterial.getCompanyName()
    },
    channelCode() {
      return this.$channelMaterial.getChannelCode()
    },
  },
  mounted() {
    this.getExpertInfo()
  },
  methods: {
    // 获取专家信息
    getExpertInfo() {
      getExpertInfo().then(res => {
        if (res.code === 200 && res.data) {
          this.expertInfo = res.data
        }
      }).catch(err => {
        console.error('获取专家信息失败:', err)
      })
    },
    // 显示修改密码弹窗
    showPasswordDialog() {
      this.passwordForm = {
        phone: this.expertInfo.phone,
        captchaCode: '',
        captchaUuid: '',
        loginPassword: '',
        confirmPassword: ''
      }
      this.passwordDialogVisible = true
    },
    // 发送短信验证码
    sendSmsCode() {
      if (this.countdown > 0) return
      if (!this.passwordForm.phone) {
        this.$message.error('手机号不能为空')
        return
      }
      sendSmsCode({ phone: this.passwordForm.phone }).then(res => {
        if (res.code === 200) {
          this.$message.success('验证码发送成功')
          this.passwordForm.captchaUuid = res.data.uuid
          this.startCountdown()
        } else {
          this.$message.error(res.msg || '发送验证码失败')
        }
      }).catch(err => {
        this.$message.error('网络异常，请稍后重试')
      })
    },
    // 开始倒计时
    startCountdown() {
      this.countdown = 60
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.clearCountdown()
        }
      }, 1000)
    },
    // 清除倒计时
    clearCountdown() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.countdown = 0
    },
    // 修改密码
    handleResetPassword() {
      if (!this.validateForm()) return
      const params = {
        phone: this.passwordForm.phone,
        captchaCode: this.passwordForm.captchaCode,
        captchaUuid: this.passwordForm.captchaUuid,
        loginPassword: this.passwordForm.loginPassword,
        channelCode: this.channelCode
      }
      resetLoginPassword(params).then(res => {
        if (res.code === 200) {
          this.$message.success('密码修改成功，请重新登录')
          this.passwordDialogVisible = false
          this.handleLogout()
        } else {
          this.$message.error(res.msg || '密码修改失败')
        }
      }).catch(err => {
        this.$message.error('网络异常，请稍后重试')
      })
    },
    // 表单验证
    validateForm() {
      const { captchaCode, loginPassword, confirmPassword } = this.passwordForm

      if (!captchaCode.trim()) {
        this.$message.error('请输入验证码')
        return false
      }
      if (!loginPassword.trim()) {
        this.$message.error('请输入新密码')
        return false
      }
      if (loginPassword.length < 6) {
        this.$message.error('密码不能少于6位')
        return false
      }
      if (!confirmPassword.trim()) {
        this.$message.error('请输入确认密码')
        return false
      }
      if (loginPassword !== confirmPassword) {
        this.$message.error('两次输入的密码不一致')
        return false
      }
      return true
    },
    // 退出登录
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Cookies.remove('token')
        this.$router.push('/expertBankLogin')
      }).catch(() => { })
    }
  },
  beforeDestroy() {
    this.clearCountdown()
  }
}
</script>

<style lang="less" scoped>
.expert-home {
  min-height: 100vh;
  background: #f5f7fa;
}

.header {
  height: 60px;
  background: linear-gradient(135deg, #4A90E2 0%, #357ABD 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  .header-left {
    display: flex;
    align-items: center;

    .logo {
      font-size: 22px;
      font-weight: bold;
      color: #fff;
      margin-right: 15px;
    }

    .title {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.9);
    }
  }

  .header-right {
    display: flex;
    align-items: center;

    .welcome {
      color: #fff;
      margin-right: 20px;
      font-size: 14px;
    }

    .el-button--text {
      color: #fff;
      font-size: 14px;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }

    .logout-btn {
      color: #ffcccc;

      &:hover {
        color: #ff9999;
      }
    }
  }
}

.main-content {
  padding: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.info-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  .card-header {
    background: linear-gradient(135deg, #4A90E2 0%, #357ABD 100%);
    color: #fff;
    padding: 15px 20px;
    font-size: 16px;
    font-weight: 500;

    i {
      margin-right: 8px;
    }
  }

  .card-body {
    padding: 30px;
    display: flex;

    .avatar-section {
      width: 150px;
      text-align: center;
      border-right: 1px solid #eee;
      padding-right: 30px;
      margin-right: 30px;

      .avatar {
        width: 100px;
        height: 100px;
        background: linear-gradient(135deg, #4A90E2 0%, #357ABD 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 15px;

        i {
          font-size: 50px;
          color: #fff;
        }
      }

      .name {
        font-size: 18px;
        font-weight: 600;
        color: #333;
      }
    }

    .info-section {
      flex: 1;

      .info-row {
        display: flex;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .info-item {
        flex: 1;
        display: flex;
        flex-direction: column;

        label {
          font-size: 13px;
          color: #999;
          margin-bottom: 8px;
        }

        span {
          font-size: 15px;
          color: #333;
          font-weight: 500;
        }
      }
    }
  }
}

.password-dialog {
  .password-form {
    .form-item {
      margin-bottom: 20px;

      label {
        display: block;
        font-size: 14px;
        color: #606266;
        margin-bottom: 8px;
      }

      &.captcha-row {
        .captcha-input-wrap {
          display: flex;

          .el-input {
            flex: 1;
            margin-right: 10px;
          }

          .el-button {
            width: 120px;
          }
        }
      }
    }
  }
}
</style>
